import * as React from 'react';

export const ViewAllSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={73}
      height={22}
      fill='none'
    >
      <path
        fill='#00B0B9'
        d='M4.527 16 .367 4.8h1.728l3.392 9.536L8.91 4.8h1.696L6.447 16h-1.92Zm7.595 0V7.968h1.6V16h-1.6Zm.8-9.568c-.299 0-.55-.096-.752-.288a.997.997 0 0 1-.288-.736c0-.288.096-.523.288-.704.203-.192.453-.288.752-.288.31 0 .565.096.768.288a.901.901 0 0 1 .304.704.97.97 0 0 1-.304.736 1.072 1.072 0 0 1-.768.288Zm6.752 9.76c-.779 0-1.467-.17-2.064-.512a3.742 3.742 0 0 1-1.408-1.472c-.33-.63-.496-1.365-.496-2.208 0-.843.165-1.579.496-2.208.341-.63.81-1.12 1.408-1.472.597-.363 1.29-.544 2.08-.544s1.466.176 2.032.528a3.507 3.507 0 0 1 1.312 1.392c.31.576.464 1.216.464 1.92v.352c0 .117-.01.245-.032.384h-6.592v-1.12h5.024c-.032-.661-.256-1.179-.672-1.552-.416-.384-.933-.576-1.552-.576-.427 0-.827.096-1.2.288-.363.192-.656.48-.88.864-.213.373-.32.848-.32 1.424v.448c0 .597.107 1.099.32 1.504.224.405.517.715.88.928.363.203.757.304 1.184.304.512 0 .933-.112 1.264-.336.341-.235.592-.544.752-.928h1.6c-.15.501-.39.95-.72 1.344-.32.384-.726.688-1.216.912-.48.224-1.035.336-1.664.336ZM26.579 16l-2.352-8.032h1.584l1.76 6.736-.32-.016 1.952-6.72h1.792l1.968 6.72h-.336l1.76-6.72h1.6L33.635 16h-1.648l-2.048-6.992h.336L28.227 16h-1.648Zm21.712.192c-.661 0-1.21-.112-1.648-.336-.437-.224-.762-.523-.976-.896a2.439 2.439 0 0 1-.32-1.232c0-.523.134-.97.4-1.344.278-.384.672-.677 1.184-.88.523-.203 1.142-.304 1.856-.304h2.096c0-.47-.07-.859-.208-1.168a1.407 1.407 0 0 0-.624-.688c-.266-.16-.608-.24-1.024-.24-.48 0-.896.117-1.248.352-.341.235-.55.576-.624 1.024H45.54c.064-.576.256-1.061.576-1.456.33-.405.752-.715 1.264-.928a4.241 4.241 0 0 1 1.648-.32c.747 0 1.376.133 1.888.4.523.267.912.645 1.168 1.136.267.48.4 1.05.4 1.712V16h-1.392l-.128-1.36a3.843 3.843 0 0 1-.416.608 2.36 2.36 0 0 1-.576.496 2.54 2.54 0 0 1-.752.32 3.15 3.15 0 0 1-.928.128Zm.304-1.296c.342 0 .65-.07.928-.208.278-.139.512-.325.704-.56.203-.245.352-.517.448-.816.107-.299.166-.613.176-.944v-.032h-1.904c-.458 0-.832.059-1.12.176-.277.107-.48.256-.608.448a1.183 1.183 0 0 0-.192.672c0 .256.059.48.176.672.128.181.31.325.544.432.235.107.518.16.848.16ZM54.525 16V4.48h1.6V16h-1.6Zm3.782 0V4.48h1.6V16h-1.6Z'
      />
      <g clipPath='url(#a)'>
        <path
          stroke='#00B0B9'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.2}
          d='m68 15 4-4-4-4'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path
            fill='#fff'
            d='M67 6h6v10h-6z'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
